import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const StoreLocatorEvents: AnalyticsBrandSettings = {
  localizadorTiendasLocalizadorTiendasDesplegarLista(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'desplegar_lista', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasDesplegarMapa(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'desplegar_mapa', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasLlamarTienda(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'llamar_tienda', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasLocalizarTiendas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const country = context.store.countryCode?.toLowerCase();
    const searchCity = componentData.buttonText;
    const search = `${country}-${searchCity}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'localizar_tiendas', search);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['75'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasLocalizarTiendasListado(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;
    const country = context.store.countryCode?.toLowerCase();
    const searchCity = componentData.buttonText;
    const search = `${country}-${searchCity}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'localizar_tiendas_listado', search);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  localizadorTiendasLocalizadorTiendasVerInfoTienda(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'ver_info_tienda', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasVerInfoTiendaListado(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'ver_info_tienda_listado', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasVerLista(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'ver_lista');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  localizadorTiendasLocalizadorTiendasVerMapa(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'ver_mapa', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasVerRuta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const storeNumber = componentData.physicalStore?.id;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'ver_ruta', storeNumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  localizadorTiendasLocalizadorTiendasVerTiendasCiudadListado(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;
    const country = context.store.countryCode?.toLowerCase();
    const searchCity = componentData.buttonText;
    const search = `${country}-${searchCity}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'ver_tiendas_ciudad_listado', search);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  envioLocalizadorLocalizar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const country = componentData.country;
    const searchCity = componentData.buttonText || 'empty';
    const search = `${country}-${searchCity}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'localizador_tiendas', 'localizar_tiendas', search);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['75'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },
};
